import { render, staticRenderFns } from "./CardFilter.vue?vue&type=template&id=4a651456&scoped=true&"
import script from "./CardFilter.vue?vue&type=script&lang=js&"
export * from "./CardFilter.vue?vue&type=script&lang=js&"
import style0 from "./CardFilter.vue?vue&type=style&index=0&id=4a651456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a651456",
  null
  
)

export default component.exports